import {
  subscribeToTimer,
  sendForm,
  validateURL,
  removeListeners,
} from '../api';
import React, { Component } from 'react';
import uuid from 'react-uuid';
import validator from 'validator';
import Select from 'react-select';
import './App.css';
import twitterIcon from '../assets/images/twitter.png';
import alertBox from '../assets/images/alert_box.png';
import spinner from '../assets/images/spinner.gif';

const id = uuid();

export class Main extends Component {
  constructor(props) {
    super(props);
    subscribeToTimer(this.state.id, (err, progress_state, progress) => {
      this.setState({ progress_state, progress });
    });
    let event = this.state.id + '_event';
    subscribeToTimer(event, (err, final_data, data) => {
      const returnJson = {
        action: 'create',
        type: final_data.type,
        file: final_data.final_data,
        fileSize: final_data.fileSize,
      };
      props.getTwitterImportedData(returnJson);

      if (window.vlogr) {
        window.vlogr.addData(1, JSON.stringify(returnJson));
      }
      if (window.webkit) {
        window.webkit.messageHandlers.addData.postMessage(returnJson);
      }
      if (window.top) {
        window.top.postMessage(returnJson, '*');
      }
      this.setState({ final_data });

      if (err) {
        const alterDiv = document.getElementById('alert_message');
        alterDiv.style.display = 'block';
        setTimeout(() => {
          alterDiv.style.display = 'none';
          this.refreshPage();
        }, 1500);
      }
    });

    this.refreshPage = this.refreshPage.bind(this);
  }

  state = {
    progress_state: 'no timestamp yet',
    progress: 0,
    id: id,
    final_data: {},
  };

  refreshPage() {
    //removeListeners();
    this.setState({ progress: 0 });
  }

  render() {
    return (
      <div className="twitter-importer-container">
        {this.state.progress > 0 ? (
          <div className={'display-div'}>
          {this.state.progress != 100 ? (
            <div>
            <div className="logo-div">
              <div
                style={{
                  float: 'left',
                  width: '33%',
                  marginLeft: '15px',
                  marginTop: '5px',
                  textAlign: '-webkit-left',
                }}
              ></div>
              <div
                style={{
                  width: '34%',
                  fontFamily: 'gothicneo',
                  fontWeight: '600',
                  fontSize: '20px',
                }}
              ></div>
              <div
                style={{
                  width: '33%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <img
                  src={twitterIcon}
                  width={'auto'}
                  height={'25px'}
                  style={{ height: '25px', marginRight: '30px' }}
                />
              </div>
            </div>
            <div className='importer-container'>
              <p className="App-intro process-header">
                {this.state.progress_state}
              </p>
              <p className="warning"> Don't turn off the app or device.</p>
              <progress
                id="file"
                className="progress_bar"
                value={this.state.progress}
                max="100"
              >
                {' '}
              </progress>
              <div className="w3-center w3-text-white text-color">
                {this.state.progress}%
              </div>
              <div>
                  <button
                    className="cancel-button"
                    type="reset"
                    onClick={() => window.location.reload()}
                  >
                    Cancel
                  </button>
              </div>
            </div>
          </div>
           ) : (<WebsocketForm />)}
           </div>
        ) : (
          <WebsocketForm />
        )}
      </div>
    );
  }
}

class WebsocketForm extends Component {
  constructor(props) {
    super(props);
    let event = 'validation_event';
    this.state = {
      message: '',
      id: id,
      errorMsg: '',
      isValidUrl: false,
      isLoading: false,
      format: 'Hd',
      optionType: 'Hd',
      defaultSelectedOpt: {},
      options: [
        { value: 'Hd', label: 'Hd' },
        { value: 'Sd', label: 'Sd' },
        { value: 'Low', label: 'Low' },
      ],
      formatOptions: [],
    };
    this.handleChangeMessage = this.handleChangeMessage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.valueLabelFormat = this.valueLabelFormat.bind(this);
    this.valuetext = this.valuetext.bind(this);
    this.fmtOptionChange = this.fmtOptionChange.bind(this);
    this.downloadOptionChange = this.downloadOptionChange.bind(this);
    subscribeToTimer(event, (err, data, p) => {
      let isError = Boolean(data.isValidUrl);
      if (!isError) {
        this.setState({ isValidUrl: false, isLoading: false });
        this.setState({
          errorMsg: 'Sorry, this URL is not recognized by our system.',
        });
      } else {
        this.setState({ isValidUrl: true, isLoading: false });
        this.setState({ defaultSelectedOpt: data.format_options[0].value});
        this.setState({ formatOptions: [...data.format_options] });
        this.setState({ errorMsg: '' });
      }
    });
  }

  valuetext = function (value) {
    return `${value}`;
  };

  valueLabelFormat = function (value) {
    return this.state.marks.findIndex((mark) => mark.value === value) + 1;
  };

  handleSubmit = function (event) {
    try {
      event.preventDefault();
      this.setState({ isValidUrl: false, isLoading: true });
      sendForm({
        message: this.state.message,
        id: this.state.id,
        format: this.state.format,
      });
    } catch (error) {
      this.setState({
        errorMsg: 'Please try again',
      });
    }
  };

  fmtOptionChange = function (event) {
    if(event && event.value ) {
      this.setState({ format: event.value });
      this.setState({ defaultSelectedOpt: event.value });
    }
  };

  downloadOptionChange = function (event) {
    this.setState({ optionType: event.value });
  };

  handleChangeMessage(event) {
    this.setState({ message: event.target.value });
    if (!validator.isURL(event.target.value)) {
      this.setState({ isValidUrl: false, isLoading: false });

      this.setState({
        errorMsg: 'Sorry, this URL was not recognized by our system.',
      });
    } else {
      this.setState({ isValidUrl: false, isLoading: true });
      validateURL(event.target.value);
    }
    if (!event.target.value) {
      this.setState({ errorMsg: '' });
    }
  }

  render() {
    return (
      <div style={{ maxWidh: '400px' }} className={'display-div'}>
        <div className="logo-div">
          <div
            style={{
              float: 'left',
              width: '33%',
              marginLeft: '15px',
              marginTop: '0px',
              textAlign: '-webkit-left',
            }}
          ></div>
          <div
            style={{
              width: '34%',
              fontFamily: 'gothicneo',
              fontWeight: '600',
              fontSize: '15px',
            }}
          >
            Import
          </div>
          <div
            style={{
              width: '33%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <img
              src={twitterIcon}
              width={'auto'}
              height={'25px'}
              style={{ height: '25px', marginRight: '30px' }}
            />
          </div>
        </div>
        <div className="container-div">
          <p
            className="App-intro process-header"
            style={{ marginTop: 100 }}
          ></p>
          <div
            id="alert_message"
            style={{
              width: '200px',
              height: '35px',
              alignItems: 'center',
              display: 'none',
              zIndex: 999,
              marginTop: '17.2em',
              marginLeft: '7em',
              position: 'absolute',
            }}
          >
            <span
              style={{
                fontSize: '13px',
                fontWeight: '400',
                fontFamily: 'Inter',
                color: '#FFFFFF',
                marginTop: '7px',
                position: 'fixed',
                marginLeft: '5px',
              }}
            >
              Please try again
            </span>
            <img src={alertBox} width="151px" height="35px" alt="Alert box" />
          </div>
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            <div className="div-label">Please enter a url below</div>
            <div>
              <input
                className="input-box"
                type="text"
                name="message"
                value={this.state.message}
                onChange={this.handleChangeMessage}
              />
            </div>
            <div
              className="div-label"
              style={{ color: 'red', marginTop: '5px' }}
            >
              {this.state.errorMsg}
            </div>
            <div>
              <div className="optDiv">
                <Select
                  id="formatOpt"
                  className={
                    this.state.isValidUrl
                      ? 'leftOptDisplay'
                      : 'leftOptNoDisplay'
                  }
                  value={this.state.formatOptions.filter(
                    (option) =>
                      option.value === this.state.defaultSelectedOpt
                  )}
                  options={this.state.formatOptions}
                  onChange={this.fmtOptionChange}
                ></Select>
              </div>
              <button
                type="submit"
                value="Import"
                width="80%"
                isLoading={this.state.isLoading}
                className={
                  this.state.isValidUrl
                    ? 'process-button'
                    : 'disable-process-button'
                }
                disabled={!this.state.isValidUrl}
              >
                {this.state.isLoading ? (
                  <img
                    className="center-align"
                    src={spinner}
                    width="21px"
                    height="21px"
                    alt="loading"
                  />
                ) : (
                  'Import'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}